module.exports = __webpack_public_path__ + "img/itp.f83c2807.png";